import React, {Component} from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import $ from 'jquery';
import {URLS} from '../urls';

export default class AddLocationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            location: {
                name: '',
                phone: '',
                email: '',
                address: {
                    apartment: '',
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                }
            },
        };
    }

    updateLocationName = (event) => {
        const {location} = this.state;
        location.name = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationPhone = (event) => {
        const {location} = this.state;
        location.phone = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationEmail = (event) => {
        const {location} = this.state;
        location.email = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationAddressApartment = (event) => {
        const {location} = this.state;
        location.address.apartment = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationAddressStreet = (event) => {
        const {location} = this.state;
        location.address.street = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationAddressCity = (event) => {
        const {location} = this.state;
        location.address.city = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationAddressState = (event) => {
        const {location} = this.state;
        location.address.state = event.target.value;
        this.setState({
            location
        });
    };
    updateLocationAddressZip = (event) => {
        const {location} = this.state;
        location.address.zip = event.target.value;
        this.setState({
            location
        });
    };
    submitLocation = (e) => {
        e.preventDefault();
        const {location} = this.state;
        const token = 'dummy token'; 
        fetch(`${URLS.backendLocations}/add`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Token ${token}`,
            },
            body: JSON.stringify({location: location}),
        }).then(res => res.json())
            .then((result) => {
                console.log("location Addition", result);
                this.props.updateLocationsList(result.location);
                // $('#add_location').hide();
                this.props.changeShowLocationState();
            });

    };

    cancelLocation = (e) => {
        e.preventDefault();
        this.props.changeShowLocationState();
        // $('#add_location').hide();
    };

    render() {
        const {location} = this.state;
        return (
            <div id='add_location' style={
                this.props.isShow ?
                    {
                        width: '50%',
                        position: 'fixed',
                        left: '50%',
                        marginLeft: '-25%',
                        top: '20px',
                        zIndex: '2000',
                        display: 'block',
                        backgroundColor: '#eaecef',
                        // height: '100%',
                        borderRadius: '10px'
                    }:{
                        width: '50%',
                        position: 'fixed',
                        left: '50%',
                        marginLeft: '-25%',
                        top: '20px',
                        zIndex: '2000',
                        display: 'none',
                        backgroundColor: '#eaecef',
                        // height: '100%',
                        borderRadius: '10px'
                    }
            }>
                <Form onSubmit={this.submitLocation} style={
                    {
                        // overflowY: 'scroll',
                        maxHeight: '100%',
                        // padding: '50px 30px',
                        borderRadius: '10px'
                    }
                }>
                    <Form.Group as={Row} style={{
                        backgroundColor: '#5378b2',
                        alignItems: 'left',
                        justifyContent: 'left',
                        fontSize: '16px',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        height:'60px',
                        borderRadius: '10px 10px 0 0',
                        padding : '10px 15px',
                        marginLeft: '0',
                        marginRight: '0',
                        display : 'block'
                    }}>
                        <span style={{display:'inline-block', height:'40px',lineHeight:'40px',float:'left'}}>Create New Location</span>
                        <span style={{display:'inline-block', height:'40px',float:'right',padding: '2px 10px'}}>
                            <button className='btn btn-info' style={
                                {
                                    padding:'2px 10px',
                                    background: '#ffffff',
                                    color: '#000000',
                                    borderRadius: '20px',
                                    border: 'none'
                                }
                            } onClick={this.cancelLocation}>x</button>
                        </span>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            Location
                        </Form.Label>
                        <Col sm={6}>
                            <Form.Control value={location.name} onChange={this.updateLocationName}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            Phone
                        </Form.Label>
                        <Col sm={6}>
                            <Form.Control value={location.phone} onChange={this.updateLocationPhone}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            Email
                        </Form.Label>
                        <Col sm={6}>
                            <Form.Control value={location.email} onChange={this.updateLocationEmail}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0'}}>
                        <Form.Label style={{fontSize: '14px'}} column sm={2}>
                            Address
                        </Form.Label>
                        <Col sm={10}>
                            <Row>
                                <Col sm={6}>
                                    <Form.Control placeholder='Apartment' value={location.address.apartment}
                                                  onChange={this.updateLocationAddressApartment}/>
                                </Col>
                                <Col sm={6}>
                                    <Form.Control placeholder='Street' value={location.address.street}
                                                  onChange={this.updateLocationAddressStreet}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: '10px'}}>
                                <Col sm={4}>
                                    <Form.Control placeholder='City' value={location.address.city}
                                                  onChange={this.updateLocationAddressCity}/>
                                </Col>
                                <Col sm={4}>
                                    <Form.Control placeholder='State' value={location.address.state}
                                                  onChange={this.updateLocationAddressState}/>
                                </Col>
                                <Col sm={4}>
                                    <Form.Control placeholder='Zip' value={location.address.zip}
                                                  onChange={this.updateLocationAddressZip}/>
                                </Col>
                            </Row>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} style={{marginLeft: '0', marginRight: '0',paddingRight: '15px', justifyContent: 'flex-end'}}>
                        <button style={{borderRadius : '7px',backgroundColor:'#5378b2', border:'none'}} className='btn btn-primary submit-btn'>Create Now</button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}